import { Controller } from "@hotwired/stimulus"

// Premium work-order part picker: searchable cards + live source-match briefing.
export default class extends Controller {
  static targets = [
    "search",
    "card",
    "empty",
    "preview",
    "previewName",
    "previewSku",
    "previewStock",
    "previewSource",
    "previewSavings",
    "previewNarrative",
    "quantity"
  ]

  connect() {
    this.selectPrecheckedCard()
  }

  filter() {
    const query = this.searchTarget.value.trim().toLowerCase()
    let visible = 0

    this.cardTargets.forEach((card) => {
      const matches = !query || card.dataset.searchText.includes(query)
      card.classList.toggle("hidden", !matches)
      if (matches) visible += 1
    })

    if (this.hasEmptyTarget) this.emptyTarget.classList.toggle("hidden", visible > 0)
  }

  choose(event) {
    const card = event.currentTarget
    const radio = card.querySelector('input[type="radio"]')
    if (radio) radio.checked = true
    this.cardTargets.forEach((candidate) => candidate.classList.toggle("is-selected", candidate === card))
    this.renderPreview(card)
  }

  selectPrecheckedCard() {
    const checked = this.cardTargets.find((card) => card.querySelector('input[type="radio"]')?.checked)
    if (checked) this.renderPreview(checked)
  }

  renderPreview(card) {
    if (!this.hasPreviewTarget) return

    this.previewTarget.classList.remove("opacity-60")
    this.previewNameTarget.textContent = card.dataset.partName || "Selected part"
    this.previewSkuTarget.textContent = card.dataset.partSku || "No SKU captured yet"
    this.previewStockTarget.textContent = card.dataset.stockLabel || "Stock unknown"
    this.previewSourceTarget.textContent = card.dataset.sourceLabel || "Source match needed"
    this.previewSavingsTarget.textContent = card.dataset.savingsLabel || "—"
    this.previewNarrativeTarget.textContent = card.dataset.narrative || "Reserve this part and MCC will keep the procurement trail attached to the work order."

    if (this.hasQuantityTarget) this.quantityTarget.focus({ preventScroll: true })
  }
}
